import LLEdito from '@/locales/Edito/fr';
import LLTrendingNow from '@/locales/TrendingNow/fr';
import LLSustainable from '@/locales/Sustainable/fr';
import LLFuturama from '@/locales/Futurama/fr';
import LLTravel from '@/locales/Travel/fr';
import LLFuture from '@/locales/Future/fr';
import LLKeyReport from '@/locales/KeyReport/fr';
import LLPioneer from '@/locales/Pioneer/fr';
import LLCulture from '@/locales/Culture/fr';
import LLBack from '@/locales/Back/fr';
import LLLegal from '@/locales/Legal/fr';

export const fr = {

    // les éléments du menu
    // pour l`edito, vu qu`il est variable en fonction du marché (present dans l`url), la structure est un peu différente
    menu: {
        EditoCH: {
            segment: `edito`,
            title: `Franck Bonin`,
            headTitle: `Édito`
        },
        EditoFR: {
            segment: `edito`,
            title: `Mathieu Vedrenne`,
            headTitle: `Édito`
        },
        EditoLU: {
            segment: `edito`,
            title: `Olivier Lecler`,
            headTitle: `Édito`
        },
        EditoMC: {
            segment: `edito`,
            title: `Nicolas Feit`,
            headTitle: `Édito`
        },
        TrendingNow: {
            segment: `tendances`,
            title: `Surprenant, innovant, bluffant… quoi de neuf ?`,
            headTitle: `Carnet de tendances`
        },
        Sustainable: {
            segment: `lin-fibre-du-futur`,
            title: `Le lin, fibre du futur`,
            headTitle: `Objectifs durables`
        },
        Futurama: {
            segment: `carte-blanche-tiina-itkonen`,
            title: `Carte blanche à Tiina Itkonen`,
            headTitle: `Futurama`
        },
        Travel: {
            segment: `venise-confidentielle`,
            title: `Venise confidentielle`,
            headTitle: `Voyager autrement`
        },
        Future: {
            segment: `montee-eaux-creer-culture-risque`,
            title: `Montée des eaux : créer une culture du risque`,
            headTitle: `Ils pensent le futur`
        },
        KeyReport: {
            segment: `fret-terre-mer-accordent-vert`,
            title: `Fret : terre et mer s'accordent sur le vert`,
            headTitle: `Le grand dossier`
        },
        Pioneer: {
            segment: `heidi-sevestre-femme-fait-parler-glaciers`,
            title: `Heïdi Sevestre, la femme qui fait parler les glaciers`,
            headTitle: `Esprit pionnier`
        },
        Culture: {
            segment: `art-explora-vision-culture-pour-tous`,
            title: `Art Explora, une vision de la culture pour tous`,
            headTitle: `Bouillon de culture`
        },
        Back: {
            segment: `origines-societe-generale`,
            title: `Aux origines de Société Générale`,
            headTitle: `Rétro(viseur)`
        },
        Legal: {
            segment: `credits-information-legales`,
            title: `Crédits & informations légales`,
            headTitle: ``
        },
    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    EditoCH: LLEdito,
    EditoFR: LLEdito,
    EditoLU: LLEdito,
    EditoMC: LLEdito,

    TrendingNow: LLTrendingNow,

    Sustainable: LLSustainable,

    Futurama: LLFuturama,

    Travel: LLTravel,

    Future: LLFuture,

    KeyReport: LLKeyReport,

    Pioneer: LLPioneer,

    Culture: LLCulture,

    Back: LLBack,

    Legal: LLLegal,


    home: {
        logoBaseLine: `Pour un monde plus&nbsp;engagé <br/>avec Société&nbsp;Générale Private&nbsp;Banking`,
        logoDate: `Printemps/Été 2024 #12`,
        title: `Heïdi Sevestre, <br/> la voix des glaciers`,
        artitle1title: `Montée des eaux : un combat planétaire`,
        artitle2title: `Sur terre ou en mer, le fret voir l'avenir en vert`,
        artitle3title: `Société Générale : 160 ans d'histoire`,
    },

    counterUpSeparator: `&nbsp;`,
    counterUpDecimal: `,`,

    next: `À suivre : `,

    readingTime: `Lecture X minute`,
    readingTimeDone: `Déjà consulté`,

    tagTheme: `Enjeux climatiques`,
};
